import { useEffect, useState } from 'react';

const useAppVisibility = (): boolean => {
  // Initialize based on current document visibility when available; default to true (visible)
  const getIsVisible = (): boolean => document.visibilityState === 'visible' && !document.hidden;

  const [isVisible, setIsVisible] = useState<boolean>(getIsVisible);

  useEffect(() => {
    const handleVisibilityChange = (): void => {
      setIsVisible(document.visibilityState === 'visible' && !document.hidden);
    };

    // Set once in case the initial render happened before the effect mounted
    handleVisibilityChange();

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isVisible;
};

export default useAppVisibility;
